<template>
  <div class="samples">
    <div
      class="sample"
      v-for="(item, index) of materials"
      :key="index"
      :ref="'sample' + index"
      :id="`ele-${item.element.id}-bg-${item.background.id}`"
      :data-tags="`${item.element.tag_ids}-${item.background.tag_ids}`"
      :class="{
        on: currentMaterialSuite?.id === `${item.element.id}-${item.background.id}`,
      }"
      @click="handleSampleClick(item, index)"
    >
      <div class="banner">
        <img v-if="item.background" class="bg" :src="item.background.src" />
        <img v-if="item.element" class="el" :src="item.element.src" />
        <div class="paperwork">
          <span class="line-1" :style="genTextStyle(item)">{{ thumbPaperwork[0] }}</span>
          <span class="line-2">{{ thumbPaperwork[1] }}</span>
        </div>
        <ai-loading v-if="isLoading" />
      </div>
    </div>
    <button @click="switchMaterial" class="sample-btn">
      <img class="refresh-icon" src="@/assets/images/index/refresh.png" />
      换风格
    </button>
    <span
      class="slide-bar"
      :style="{
        left: slideBarPosition.left,
      }"
    ></span>
  </div>
</template>
<script>
import AiLoading from "./ai-loading.vue";
export default {
  name: "AiSamples",
  components: {
    AiLoading,
  },
  props: {
    materialSuites: {
      type: Array,
      default: () => [],
    },
    currentMaterialSuite: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    thumbPaperwork: {
      type: Array,
      default: () => ["", ""],
    },
  },
  data() {
    return {
      slideBarPosition: {
        left: "0px",
        width: "80px",
      },
      currentIndex: 0,
      displayCount: 4,
    };
  },
  computed: {
    materials() {
      if (!this.materialSuites.length) {
        const obj = {
          id: Math.random(),
          element: {
            src: "",
          },
          background: {
            src: "",
          },
        };
        return Array(this.displayCount).fill(obj);
      }
      return this.materialSuites.slice(this.currentIndex, this.currentIndex + this.displayCount);
    },
  },
  watch: {
    materialSuites(newVal) {
      this.initializeSlideBar();
    },
  },
  mounted() {
    this.initializeSlideBar();
  },
  methods: {
    genTextStyle(materialSuite) {
      const { tagBgColor } = materialSuite.background;
      let themeColor = tagBgColor || "#D6DBE0";
      themeColor = themeColor.includes(",") ? themeColor : `${themeColor}, ${themeColor}`;
      return {
        background: `linear-gradient(90deg, ${themeColor})`,
      };
    },
    switchMaterial() {
      this.currentIndex = this.currentIndex + this.displayCount;
      if (this.currentIndex >= this.materialSuites.length) {
        this.currentIndex = 0;
      }
      this.$emit("switchStyle", this.materialSuites[this.currentIndex]);
      this.moveSlideBar(0);
      // this.handleSampleClick(this.materialSuites[this.currentIndex], 0);
    },
    handleSampleClick(materialSuite, index) {
      this.$emit("checkMaterialSuite", materialSuite);
      this.moveSlideBar(index);
    },
    moveSlideBar(index) {
      this.$nextTick(() => {
        const samples = this.$refs[`sample${index}`];
        if (!samples) return;
        const sample = samples[0];
        if (sample) {
          const parentRect = sample.parentElement.getBoundingClientRect();
          const sampleRect = sample.getBoundingClientRect();
          const left = sampleRect.left - parentRect.left + (sampleRect.width - 80) / 2;
          this.slideBarPosition.left = `${left}px`;
        }
      });
    },
    // 初始化滑动条
    initializeSlideBar() {
      const activeIndex = this.materialSuites.findIndex(suite => suite.id === this.currentMaterialSuite?.id);
      // 每四个为一组，找出activeIndex在某一组的第几个
      const order = activeIndex % this.displayCount;
      // 当前组的第一个元素的index
      this.currentIndex = Math.floor(activeIndex / this.displayCount) * this.displayCount;
      this.moveSlideBar(order);
    },
  },
};
</script>
<style lang="scss" scoped>
.samples {
  position: relative;
  display: flex;
  justify-content: start;
  gap: 24px;
  height: 200px;
  padding: 24px 0;
  max-width: 1230px;
  width: 98%;
  margin: 0 auto;
  cursor: pointer;
  .sample-btn {
    position: absolute;
    margin: 0;
    width: 152px;
    height: 48px;
    right: 0;
    top: 50%;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    transform: translateY(-50%);
    border-radius: 100px;
    border: none;
    cursor: pointer;
    background: rgba(148, 131, 255, 0.3);
    transition: all 0.3s;
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      border-radius: 100px;
      background: rgba(33, 37, 49, 0.9);
      cursor: pointer;
      z-index: -1;
      transition: all 0.3s;
    }
    &:after {
    }
    .refresh-icon {
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
    &:hover {
      background: linear-gradient(90deg, #8569d9, #43bbff, #8093f7);
      &:after {
        background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
      }
    }
  }
  .sample {
    position: relative;
    width: 220px;
    height: 152px;
    padding: 14px;
    border-radius: 16px;
    background: rgba(148, 131, 255, 0.3);
    &:after,
    &:before {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      border-radius: 14px;
      background: #242931;
      cursor: pointer;
    }
    &:after {
      z-index: 0;
      background: rgba(33, 37, 49, 0.9);
    }
    .banner {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      .bg {
        position: absolute;
        z-index: 1;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      .el {
        position: absolute;
        z-index: 2;
        height: auto;
        width: 400px;
        bottom: 0;
        right: 0;
        transform: translateX(40px);
      }
      .paperwork {
        position: absolute;
        top: 20px;
        left: 0px;
        padding-top: 1px;
        width: 110px;
        z-index: 3;
        padding-left: 12px;
        height: 80px;
        text-align: left;
        .line-1 {
          display: inline-block;
          height: 18px;
          padding: 0 6px;
          line-height: 18px;
          font-size: 14px;
          color: #fff;
          border-radius: 2em;
        }
        .line-2 {
          display: block;
          margin-top: 2px;
          color: rgb(255, 255, 255);
          font-size: 18px;
          font-family: "阿里巴巴普惠体 Heavy";
          line-height: 20px;
          min-height: 20px;
        }
      }
    }
    &.on,
    &:hover {
      background: linear-gradient(90deg, #8569d9, #43bbff, #8093f7);
      &:before {
        z-index: 1;
        background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
      }
      box-shadow: 0px 0px 0px 1px rgba(244, 244, 245, 0.05), 0px 0px 0px 0px #fff;
    }
  }
  .slide-bar {
    position: absolute;
    bottom: 0;
    height: 4px;
    width: 80px;
    border-radius: 10px;
    background: linear-gradient(90deg, #8569d9 23%, #43bbff 50.56%, #8093f7 83.5%);
    transition: left 0.3s ease, width 0.3s ease;
  }
}
@media screen and (max-width: 1590px) {
  .samples {
    gap: 12px;
    .sample {
      width: 198px;
      height: 136px;
      .banner .paperwork {
        top: 14px;
        .line-1 {
          height: 16px;
          padding: 0 6px;
          line-height: 16px;
          font-size: 12px;
        }
        .line-2 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
